module.exports = __webpack_public_path__ + "media/pages/auth/images/social-1805ff7db368cc3b696bb79a91c451a8.png";